import { useContext, useState, useEffect } from "react";
import "./adminnavbar.scss";

import { AuthContext } from "../../context/AuthContext";
import { useNotificationStore } from "../../lib/notificationStore.js";
import LinkWithCallback from "../linknav/LinkWithCallback.jsx"; // Import the custom Link component

import logo from "../../assets/logo.png";
import noavatar from "../../assets/noavatar.png";
import menuIcon from "../../assets/menu.png";
import noimage from "../../assets/no-image-icon-23494.png";


import { useChat } from "../../context/chatContext.jsx";
import { isLocalhost } from "../../../checkLocalhost.jsx";



function AdminNavbar() {

  // console.log("🔥 Vite Build 2025-06-24 21:30 - USING logo.png");
  // console.log("🔥 FORCING BUILD REFRESH");
  // console.log("BASE_URL:", import.meta.env.BASE_URL);
  const { unreadCount } = useChat();


  const [open, setOpen] = useState(false);
  const { currentUser } = useContext(AuthContext);


  const avatarfolder=import.meta.env.VITE_AVATARIMAGE_FOLDER
  const avatarimagelocation =isLocalhost
    ?import.meta.env.VITE_AVATARIMAGES_BASEURL + currentUser?.id + avatarfolder
    :import.meta.env.VITE_AVATARIMAGES_SH_BASEURL + currentUser?.id + avatarfolder



  const fetchNotifications = useNotificationStore((state) => state.fetch);
  const number = useNotificationStore((state) => state.number);

  useEffect(() => {
    if (currentUser){
      fetchNotifications();
    }
  }, [fetchNotifications,currentUser]);  

  useEffect(() => {

  }, [currentUser]);





  
  return (
    
    <div className="adminnavbar">    
        <div className="left">
          <LinkWithCallback to="/" className="logo">
            <img src={logo} alt="" />
            <span className="company">Bhoomi India Realtors</span>
            <span className="companydesc">Sale Purchase Renting and Collaborations</span>
          </LinkWithCallback>
        </div>
        <div className="middle">
          <div className="links">
                  <LinkWithCallback to="/admin/masters">Masters</LinkWithCallback>
                  <LinkWithCallback to="/">Clients</LinkWithCallback>
                  <LinkWithCallback to="/">Users</LinkWithCallback>
                  <LinkWithCallback to="/admin/data">Data</LinkWithCallback>
                  <LinkWithCallback to="/">Property Management</LinkWithCallback>
          </div>
        </div>


        <div className="right">
            {currentUser ? (
              <div className="user">
                  <img
                    src={
                        !currentUser.avatar
                          ? noavatar
                          : currentUser.avatar.startsWith("https")
                          ? currentUser.avatar
                          : currentUser.avatar.startsWith("http")
                          ? noavatar // fallback for non-https URLs
                          : avatarimagelocation + currentUser.avatar
                        }
                        alt=""
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop if fallback also fails
                      e.target.src = noimage; // Fallback image URL or local path
                      e.target.style.width = '40px';
                      e.target.style.height = '40px';
                      e.target.style.display = 'block';
                    }}
                  />

                  
                <LinkWithCallback to="/dashboard/inbox" className="profile">
                  <div className="profile-content">
                    <span>{currentUser.username}</span>
                    {unreadCount > 0 && <div className="notification">{unreadCount}</div>}
                  </div>
                </LinkWithCallback>
              </div>
            ) : 
              <>
                <LinkWithCallback to="/login" className="signin">Sign in</LinkWithCallback>
                <LinkWithCallback to="/register" className="register">
                    Sign up            
                </LinkWithCallback>

              </>
            }
    

          <div className="menuIcon">          
            <img
              src={menuIcon}
              alt=""
              onClick={() => setOpen((prev) => !prev)}
            />
          </div>

          <div className={open ? "menu active" : "menu"}>
            {/* <LinkWithCallback to="/">Floors</LinkWithCallback>
            <LinkWithCallback to="/">Flats</LinkWithCallback>
            <LinkWithCallback to="/">Houses</LinkWithCallback>
            <LinkWithCallback to="/">Farms</LinkWithCallback>
            <LinkWithCallback to="/login">Sign in</LinkWithCallback>
            <LinkWithCallback to="/register">Sign up</LinkWithCallback>
            <LinkWithCallback to="/profile">Profile</LinkWithCallback> */}
              {/* // this is supposed to be for mobile view */}
          </div>
      </div>
    </div>
    

  );
}

export default AdminNavbar;
